import { Capsule } from 'ccs-ui-components';
import { useTranslation } from 'react-i18next';
import ImportedEventsSummary from '../imported-events-summary/ImportedEventsSummary';
import { useSelector } from '../../../../store/AppStore';
import { IMPORT_FILE_STATUS_CLASSTYPES } from '../../../../constants';

import classes from './ImportFiles.module.scss';

const ImportFiles = () => {
  const { t: translate } = useTranslation();

  const { config } = useSelector(
    (state) => state.postImportEvents
  );

  /**
   * @method renderConfigValue
   * @description Renders a configuration value as a pill with specified text style.
   * @param status - The status of the configuration value.
   * @returns The rendered pill component.
   */
  const renderConfigValue = (status: string, textStyle: string) => (
    <div className={classes['pill-text']}>
      <Capsule className={textStyle} text={status.charAt(0).toLocaleUpperCase() + status.slice(1).toLocaleLowerCase()} />
    </div>
  );

  return (
    <>
      <div className={classes['import-files-notification-header']}>
        <p className={classes['import-files-notification-header-text']}>
          {translate('import_summary.imported_configurations')}
        </p>
        <div className={classes['import-files-notification-config-details']}>
          <div className={classes['import-files-notification-config-detail']}>
            <div className={classes['import-files-notification-config-detail-key']}>
              {translate('import_summary.source_env')}
            </div>
            <div className={classes['import-files-notification-config-detail-value']}>
              {renderConfigValue(config?.sourceEnv, IMPORT_FILE_STATUS_CLASSTYPES.INACTIVE)}
            </div>
          </div>
        </div>
        <div className={classes['config-count-summary']}>
          <p className={classes['config-count-summary-text']}>{renderConfigValue(config?.totalSuccessRecordsCount?.toLocaleString(), IMPORT_FILE_STATUS_CLASSTYPES.SUCCESS)} {translate('import_summary.success_config_count')} </p>
          <p className={classes['config-count-summary-text']}> {renderConfigValue(config?.totalFailureRecordsCount?.toLocaleString(), IMPORT_FILE_STATUS_CLASSTYPES.FAILED)} {translate('import_summary.failed_config_count')}</p>
        </div>
      </div>
      {config?.records
        && <ImportedEventsSummary records={config?.records} />}
    </>
  );
};

export default ImportFiles;
